__turbopack_context__.v({
  "container": "enrollment-sticky-footer-content-module-scss-module___SQv0W__container",
  "enroll-now-cta-button": "enrollment-sticky-footer-content-module-scss-module___SQv0W__enroll-now-cta-button",
});
